module.exports = __webpack_public_path__ + "static/gcgmonash-873c95ddaeb73d4908478f21e2c45924.png";